module.exports = __webpack_public_path__ + "static/media/whatsapp-square.ad0ff3be.svg";